(function ($, Drupal, once) {
  Drupal.behaviors.copyProximityDistance = {
    attach(context) {
      once('copy-proximity-distance', '.views-row', context).forEach((row) => {
        const target = row.querySelector('.distance .proximity');

        // If proximity is already rendered by Twig, keep it.
        if (target && target.textContent.trim()) {
          return;
        }

        const source = row.querySelector(
            '.views-field-field-location-proximity .proximity'
        );

        if (!source) {
          return;
        }

        const distance = source.textContent.trim();

        // Do not copy 0.00km.
        if (distance === '0.00km') {
          return;
        }

        // If the target element doesn't exist, create it.
        const distanceWrapper = row.querySelector('.distance');

        if (!distanceWrapper) {
          return;
        }

        const proximity = document.createElement('div');
        proximity.className = 'proximity';
        proximity.textContent = distance.replace('km', ' km');

        distanceWrapper.insertBefore(proximity, distanceWrapper.firstChild);
      });
    }
  };
})(jQuery, Drupal, once);